const isDebug = () => {
  if (typeof window !== 'undefined') {
    return process.env.NEXT_PUBLIC_ENABLE_DEBUG === 'true' || process.env.NODE_ENV !== 'production';
  }
  return process.env.NEXT_PUBLIC_ENABLE_DEBUG === 'true' || process.env.NODE_ENV !== 'production';
};

export const logger = {
  info: (...args: unknown[]) => {
    if (isDebug()) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isDebug()) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },
  error: (...args: unknown[]) => {
    // Always allow errors
    // eslint-disable-next-line no-console
    console.error(...args);
  },
};

export default logger;


